import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var RecuperarContrasenaService = /** @class */ (function () {
    function RecuperarContrasenaService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.baseUrl;
    }
    RecuperarContrasenaService.prototype.postRecuperarContrasena = function (username) {
        return this.httpClient.post(this.baseUrl + '/recuperar-contrasena', {
            usuario: username
        });
    };
    RecuperarContrasenaService.prototype.postVerificarRecuperacionContrasena = function (token) {
        return this.httpClient.post(this.baseUrl + '/verficar-recuperacion', {
            token: token
        });
    };
    RecuperarContrasenaService.prototype.postCambiarContrasena = function (password, confirmPassword, token) {
        return this.httpClient.post(this.baseUrl + '/cambiar-contrasena', {
            nuevaContrasena: password,
            confirmarContrasena: confirmPassword,
            token: token
        });
    };
    RecuperarContrasenaService.ngInjectableDef = i0.defineInjectable({ factory: function RecuperarContrasenaService_Factory() { return new RecuperarContrasenaService(i0.inject(i1.HttpClient)); }, token: RecuperarContrasenaService, providedIn: "root" });
    return RecuperarContrasenaService;
}());
export { RecuperarContrasenaService };
